import { useMutation } from '@tanstack/react-query'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'

interface ProofOfCoverageUploadProps {
  file: File
}

interface ProofOfCoverageResponse {
  file_name: string
  file_id: string
}

export const useUploadProofOfCoverage = ({ planYear }: { planYear?: string }) => {
  return useMutation<ProofOfCoverageResponse, GrapeAPIErrorType, ProofOfCoverageUploadProps>({
    mutationFn: async (data: ProofOfCoverageUploadProps) => {
      const formData = new FormData()
      formData.append('file', data.file)
      if (planYear) {
        formData.append('plan_year', planYear)
      }

      // TODO: add eslint-disable-next-line for bare fetch
      const response = await fetch(
        '/api/web/member_onboarding/proof_of_coverage/upload', // eslint-disable-line thatch/no-bare-fetch
        {
          method: 'POST',
          body: formData,
          headers: {
            Accept: 'multipart/form-data',
          },
        }
      )

      if (!response.ok) {
        const errors = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json()
    }
  })
}
